import { opsEmAbertoPorParceiroStyle } from './OpsEmAbertoPorParceiro.style'

export function opsEmAbertoPorParceiroIO() {
  return {
    styles: opsEmAbertoPorParceiroStyle
  }
}

export type OpsEmAbertoPorParceiroIO = ReturnType<typeof opsEmAbertoPorParceiroIO>
